import { ContentType, ContentTypeToStorageKeyMap } from "../Common/ContentType";
import { ISourcedUserFact, IUserFact, UserFactSource } from "../Common/Models";
import { getCachedContent, getValidCachedContent } from "../Utils/Caching";

export const UserFactLocalStorageKey = ContentTypeToStorageKeyMap[ContentType.userFacts];

// Get UserFacts
export function getCachedUserFacts(userId?: string): IUserFact[] {
	return getCachedContent(UserFactLocalStorageKey);
}

// Get UserFacts
export function getUnExpiredCachedUserFacts(userId?: string): IUserFact[] {
	return getValidCachedContent(UserFactLocalStorageKey, null);
}

// Merges or appends local UserFacts into the input array (usually remote facts)
export function mergeLocalUserFacts(inputUserFacts?: IUserFact[]): IUserFact[] {
	const localUserFacts: IUserFact[] = getCachedContent(UserFactLocalStorageKey);
	if (!localUserFacts) {
		return inputUserFacts;
	}

	if (!inputUserFacts) {
		return localUserFacts;
	}

	localUserFacts.forEach(localFact => {
		const localSourcedFact = localFact as ISourcedUserFact;
		if (localSourcedFact?.source == UserFactSource.Local) {
			const matchingInputFact = inputUserFacts.find(inputFact => inputFact.userFactName == localFact.userFactName);
			if (!matchingInputFact) {
				// if the local fact doesn't exist in input/remote list, then append to the list
				inputUserFacts.push(localSourcedFact);
				return;
			}

			// if local fact is newer, update the fact value from local cache
			if (localFact.sourceDateTime > matchingInputFact.sourceDateTime) {
				matchingInputFact.sourceDateTime = localFact.sourceDateTime;
				matchingInputFact.userFactValue = localFact.userFactValue;
				(matchingInputFact as ISourcedUserFact).source = UserFactSource.Local;
			}
		}
	});

	return inputUserFacts;
}
